import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import DialogContentText from '@material-ui/core/DialogContentText';

class ConfirmMessage extends React.Component {
  constructor(props) {
    super(props);

    this.handleValidate = this.handleValidate.bind(this);
  }

  componentDidMount() {
    // We need to pass component reference to parent (= DialogItem)
    const { onRef } = this.props;
    onRef(this);
  }

  // Handlers called by parent (= DialogItem)
  handleValidate() {
    const { onValidate } = this.props;
    onValidate();
    return true;
  }

  render() {
    const { message } = this.props;

    return (
      <DialogContentText>
        {message}
      </DialogContentText>
    );
  }
}

ConfirmMessage.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  onRef: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

module.exports = ConfirmMessage;



// WEBPACK FOOTER //
// ./components/dialogs/ConfirmMessage.js